<template>
  <div class="registered">
    <!-- 头部 -->
    <div class="registered-top">
      <img src="../../assets/img/login/logo-h.png" alt="" />
      <p @click="toHome">返回首页<span></span></p>
    </div>
    <!-- 注册主体 -->
    <div class="registered-body">
      <div class="registered-con">
        <!-- 注册表单 -->
        <registerForm @showSuccessMsg="showSuccessMsg"></registerForm>
      </div>
    </div>
    <!-- 底部 -->
    <div class="registered-footer">
      &reg; 2014-2019 杭州云智互联科技有限公司
    </div>
    <fade-down-modal :show="showSuccess">
      <div style="width:600px;height:240px;margin:0 auto;background:#fff;">
        <success-msg :showSuccess="showSuccess" :title="'注册账号'" :msg="'恭喜，注册成功！'" :msgTwo="'稍后自动跳转登录页，如未跳转，请手动点击。'">
        </success-msg>
      </div>
    </fade-down-modal>
  </div>
</template>

<script>
import FadeDownModal from "_c/modals/fadeDown";
import successMsg from "../reset/successMsg";
import PAGE_API from "@/apis/pageApi";
import registerForm from "./registerForm";

export default {
  name: "register",
  components: {
    FadeDownModal,
    successMsg,
    registerForm
  },
  data () {
    return {
      showSuccess: false
    };
  },
  methods: {
    showSuccessMsg () {
      this.showSuccess = true;
    },
    //去登录页
    toLogin () {
      this.$router.push({
        path: PAGE_API.login.path
      });
    },
    toHome () {
      window.location.href = "/";
    }
  }
};
</script>

<style lang="scss">
.registered {
  width: 100%;
  height: 100vh;
  min-height: 920px;
  background-color: #f5f5f6;
  background-size: cover;
  background-position: center;
  position: relative;

  // 头部
  .registered-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 60px;
    background-color: #f5f5f6;
    border-bottom: 1px solid #d7d8d9;

    img {
      margin-left: 30px;
      width: 124px;
      height: 30px;
    }

    p {
      margin-right: 20px;
      font-size: 15px;
      color: #383d41;
      font-weight: bold;
      cursor: pointer;

      span {
        display: block;
        float: right;
        margin-top: 4px;
        margin-left: 5px;
        width: 12px;
        height: 12px;
        background: url(../../assets/img/icon/箭头.png);
      }
    }

    p:hover {
      color: #00c2de;
    }
  }

  // 注册主体
  .registered-body {
    display: flex;
    justify-content: center;
    width: 100%;
    background-size: 90% 100%;
    background-position: center bottom;

    .registered-con {
      display: flex;
      justify-content: center;
      margin-top: 80px;
      width: 1000px;
      height: 570px;
      background-color: #fff;
      // 注册表单
    }
  }

  // 底部
  .registered-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 60px;
    background-color: #383d41;
    color: #84878c;
    text-align: center;
    line-height: 60px;
    font-size: 12px;
  }
}

.register-wrong {
  position: absolute;
  // transform: translate(330px,-35px);
  width: 620px;
  line-height: 40px;
  text-align: left;
  color: #f00;
  font-size: 12px;
}

.name-wrong {
  position: absolute;
  transform: translate(340px, -30px);
  color: #f00;
  font-size: 12px;
}

.password-wrong {
  position: absolute;
  transform: translate(340px, -30px);
  color: #f00;
  font-size: 12px;
}

input::placeholder {
  color: rgb(161, 161, 161);
}

.checkbox {
  width: 100%;
  padding: 10px 0;
  text-align: left;
  font-size: 14px;
  line-height: 12px;

  a {
    cursor: pointer;
    color: #00c2de;
  }
}

.check {
  float: left;
  margin-right: 5px;
}
</style>
